import { useState,useEffect } from "react"
import { apiFetch } from '@/lib/api'
import { FaDownload, FaPlay, FaStop, FaTrash, FaAngleLeft, FaCloudUploadAlt, FaAngleRight } from "react-icons/fa";
import { MdCheckBoxOutlineBlank, MdCheckBox, MdOutlineCheckBox   } from "react-icons/md";
import { PiFileDashedLight } from "react-icons/pi";

import { getFileUrl } from "@/lib/s3"
import AsyncToggle from "./AsyncToggle"
import EditableText from "./EditableText"
import WscBrowser from "./WscBrowser"
import Button from "./ui/Button"
import ShowAssetsBrowser from "./ShowAssetsBrowser"
import AssetEditorModal from "./modals/AssetEditorModal";
import { useModal } from "@/contexts/ModalContext";
import { FiPlus, FiX, FiDownload, FiTrash, FiEdit2, FiMessageCircle, FiEdit, FiEdit3, FiUpload, FiSettings, FiImage} from "react-icons/fi"
import { RiImageEditLine } from "react-icons/ri"
import { LuBrainCircuit } from "react-icons/lu"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import ConfirmModal from "./modals/ConfirmModal";
import VideoPreviewModal from "./modals/VideoPreviewModal";
import ImagePreviewModal from "./modals/ImagePreviewModal";
import AudioPreviewModal from "./modals/AudioPreviewModal";
import { LuAudioLines, LuLoaderCircle } from "react-icons/lu";
import useFileUpload from "@/hooks/useFileUpload";
import { Progress } from "./ui/shadcn/progress"
import Loader from "./loader"
import { useShow } from "@/contexts/ShowContext"
import { Checkbox } from "./ui/shadcn/checkbox"
import { Input } from "./ui/shadcn/input"
import AssetThumbnail from "./AssetThumbnail";
import CommentsEditorModal from "./modals/CommentsEditorModal";
import { SketchEditor } from "./SketchEditor"
import { DragPreviewProvider } from "./ui/DragPreview"

const Asset = ({asset, onEdit, onDelete, onDownload, onStatusChange, onPreview, onComment, onAgent, onSketchEdit}) =>{
    const [loading, setLoading] = useState(false)
    const {show} = useShow()
    const getName = () =>{
        return asset.type==='script' ? asset.text : asset.name
    }

    const getThumb = () =>{
        return asset.type==='script' ? asset.character?.thumbnail_url : asset.thumbnail_url
    }

    const handleOnEdit = async () =>{
        setLoading(true)
        if (onEdit) await onEdit(asset)
        setLoading(false)
    }

    const handleOnDelete = async () =>{
        setLoading(true)
        if (onDelete) await onDelete(asset)
        setLoading(false)
    }

    const handleOnComments = async () => {
        setLoading(true)
        if (onComment) await onComment(asset)
        setLoading(false)
    }


    return (
        <div className='flex flex-col gap-1 relative group'>
            <div className='flex justify-center items-center h-full relative aspect-video group/thumbnail bg-secondary rounded-md overflow-hidden'>
                <div onClick={() => onPreview(asset)} className='cursor-pointer w-full h-full'>
                    <AssetThumbnail asset={asset} />
                </div>
                
                <div className="absolute top-0 left-0 flex flex-wrap gap-1 p-1 pointer-events-none">
                    {asset.tags.map(tag => <span key={tag} className='text-[11px] py-[1px] px-1 rounded-sm capitalize bg-primary text-primary-foreground'>{show.asset_categories.find(t => t._id === tag)?.name}</span>)}
                </div>

                <div className='absolute bottom-0 right-0 p-1 hidden group-hover:flex'>
                    <div className='flex items-center bg-card rounded-lg border'>
                        {/* <div className="p-2 flex items-center justify-center text-secondary-foreground/80 hover:text-secondary-foreground cursor-pointer" onClick={handleOnComments}>
                            <FiMessageCircle className="w-3 h-3" />
                        </div> */}
                        <div className="p-2 flex items-center justify-center text-secondary-foreground/80 hover:text-secondary-foreground cursor-pointer" onClick={() => onAgent(asset)}>
                            <LuBrainCircuit className="w-3 h-3" />
                        </div>
                        {asset.mediaType==='image' && (
                            <div className="p-2 flex items-center justify-center text-secondary-foreground/80 hover:text-secondary-foreground cursor-pointer" onClick={() => onSketchEdit(asset)}>
                                <FiImage className="w-3 h-3"  />
                            </div>
                        )}
                        <div className="p-2 flex items-center justify-center text-secondary-foreground/80 hover:text-secondary-foreground cursor-pointer" onClick={handleOnEdit}>
                            <FiSettings className="w-3 h-3" />
                        </div>
                        {asset.url && <div className="p-2 flex items-center justify-center text-secondary-foreground/80 hover:text-secondary-foreground cursor-pointer" onClick={() => onDownload(asset)}>
                            <FiDownload className="w-3 h-3"/>
                        </div>}
                        <div className="p-2 flex items-center justify-center text-destructive-foreground/80 hover:text-destructive-foreground cursor-pointer " onClick={handleOnDelete}>
                            <FiTrash className="w-3 h-3" />
                        </div>
                    </div>
                </div>
                
                {loading && <div className='absolute top-0 left-0 w-full h-full bg-black/60 text-white flex items-center justify-center'>
                    <LuLoaderCircle className='w-6 h-6 animate-spin' />
                </div>}
            </div>
            <div className='flex gap-2 flex-col items-start px-1'>
                {/* <AsyncToggle className='py-1' onChange={(e) => onStatusChange(asset, e)} isChecked={asset.status==='approved'} onText="Approved" offText="Draft" onValue="approved" offValue="draft" 
                    checkedIcon={<MdCheckBox className='w-4 h-4 text-green-500' />} uncheckedIcon={<PiFileDashedLight className='w-4 h-4 text-gray-300'  />} 
                /> */}
                <span className='text-xs text-secondary-foreground group-hover:text-white'>{getName()}</span>
                
            </div>
            
        </div>
    )
}

export default function AssetsEditor({onModeChange, mediaTypes='image/*,video/*,audio/*', episodeId='', segmentId='', sceneId='',tags=[]}) {
    const [assets, setAssets] = useState([])
    const [showAssets, setShowAssets] = useState([])
    const [loading, setLoading] = useState(false)
    const [loadingStatus, setLoadingStatus] = useState('')
    const [mode, setMode] = useState('assets')
    const {show} = useShow()
    const {openModal} = useModal()
    const navigate = useNavigate()
    const {uploadFile, uploadProgress, isUploading} = useFileUpload()
    const [isDragOver, setIsDragOver] = useState(false)
    const [selectedFilterTags, setSelectedFilterTags] = useState(show.asset_categories.map(tag => tag._id))
    const [showUntagged, setShowUntagged] = useState(true)
    const [showDraft, setShowDraft] = useState(true)
    const [showApproved, setShowApproved] = useState(true)
    const [searchString, setSearchString] = useState('')
    const [searching, setSearching] = useState(false)
    
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(50)
    const [totalPages, setTotalPages] = useState(1)
    const [totalAssets, setTotalAssets] = useState(0)
    const [sketchEditorState, setSketchEditorState] = useState(null)
    const [editingAssetId, setEditingAssetId] = useState(null)

    const fetchAssets = async(pageIndex)=>{
        try{
            const assetsResponse = await apiFetch(`/api/shows/${show._id}/assets?page=${pageIndex || page}&search=${searchString}&tags=${selectedFilterTags.map(tag => tag).join(',')}&showUntagged=${showUntagged}&showDraft=${showDraft}&showApproved=${showApproved}`)
            if (!assetsResponse.ok) throw new Error('Failed to fetch assets')
            const assetsData = await assetsResponse.json()

            setPage(assetsData.page)
            setTotalPages(assetsData.totalPages)
            setTotalAssets(assetsData.totalAssets)
            setPageSize(assetsData.pageSize)
            setAssets(assetsData.assets)
        } catch (error) {
            console.error('Error fetching assets:', error)
            setLoading(false)
        }
    }

    useEffect(()=>{
        const getData = async()=>{
            setPage(1)
            setSearching(true)
            await fetchAssets(1)
            setSearching(false)
        }
        getData()
    },[searchString, selectedFilterTags, showUntagged, showDraft, showApproved])


    const handlePreviousPage = async() => {
        if (page > 1) {
            setPage(page - 1)
            setLoading(true)
            await fetchAssets(page-1)
            setLoading(false)
        }
    }
    
    const handleNextPage = async () => {
        if (page < totalPages) {
            setPage(page + 1)
            setLoading(true)
            await fetchAssets(page+1)
            setLoading(false)
        }
    }

    const handleDelete = async (asset) => {
        const confirm = await openModal(<ConfirmModal title="Delete Asset" message={`Are you sure you want to delete this '${asset.name}'?`} />)

        if(!confirm) return

        try{
            const assetResponse = await apiFetch(`/api/shows/${show._id}/assets/${asset._id}`, {
                method: 'DELETE'
            })
            if (!assetResponse.ok) throw new Error('Failed to delete asset')

            await fetchAssets()
        } catch (error) {
            console.error('Error in delete:', error)
        }
    }

    const handleStatusChange = async (asset, status) => {
        try{
            const response = await apiFetch(`/api/shows/${show._id}/assets/${asset._id}`, {
                method: 'PUT',
                body: JSON.stringify({status})
            })
            if (!response.ok) throw new Error('Failed to update asset')
            await fetchAssets()
        } catch (error) {
            console.error('Error in status change:', error)
        } 
    }

    const handleDownload = async(asset) => {
        try {
            const response = await fetch(asset.url);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = asset.name || 'video.mp4';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    const handleWscImport = async (assets) => {
        try{
            setLoading(true)
            
            for(const asset of assets){
                try {
                    setLoadingStatus(`Importing ${asset.name}`)
                    const assetResponse = await apiFetch(`/api/shows/${show._id}/assets?episode=${episodeId}&segment=${segmentId}&scene=${sceneId}`, {
                        method: 'POST',
                        body: JSON.stringify({
                            mediaType:'video',
                            name : asset.name,
                            url : asset.videoUrl,
                            source : 'wsc_import',
                            thumbnail_url : asset.thumbnailUrl2,
                            tags : show.wsc_asset_categories
                        })
                    })

                    if (!assetResponse.ok) throw new Error('Failed to create asset')
                } catch (error) {
                    console.error('Error importing asset:', error)
                }
            }

            await fetchAssets()
        } catch (error) {
            console.error('Error in import:', error)
        } finally {
            setLoadingStatus('')
            setLoading(false)
            setMode('assets')
        }
    }

    const handleEditAsset = async (asset) => {
        let assetData;

        assetData = await openModal(<AssetEditorModal asset={asset} />, 'side')

        if(!assetData) return

        try{
            if(!asset) setLoading(true)
            let uploadResponse = {}

            if(assetData.file){
                setLoadingStatus(`Uploading: ${assetData.file.name}`)
                uploadResponse = await uploadFile(assetData.file)
                assetData.mediaType = assetData.file.type.split('/')[0]
                delete assetData.file
            }
            
            setLoadingStatus(`Saving: ${assetData.name}`)
            const assetResponse = await apiFetch(`/api/shows/${show._id}/assets/${asset?._id || ''}`, {
                method: asset?._id ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...assetData,
                    ...uploadResponse,
                    source : 'upload'
                })
            })

            if (!assetResponse.ok) throw new Error('Failed to add asset')

            await fetchAssets()

        } catch (error) {
            console.error('Error in file select:', error)
        } finally{
            setLoading(false)
            setLoadingStatus('')
        }
    }

    const handleComment = async (asset) => {
        const comment = await openModal(<CommentsEditorModal uid={asset._id} />, 'side')
        if(comment) {
            await fetchAssets()
        }
    }

    const handleAssetsPreview = (asset) => {
        if(asset.mediaType === 'video'){
            openModal(<VideoPreviewModal video={asset} />)
        } else if(asset.mediaType === 'audio'){
            openModal(<AudioPreviewModal audio={asset} />)
        } else if(asset.mediaType==='image') {
            openModal(<ImagePreviewModal image={asset} />)
        }
    }

    const handleAgent = async (asset) => {
        try {
            const res = await apiFetch(`/api/shows/${show._id}/conversations`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: 'New Chat',
                    assets: [{ url: asset.url, type: asset.mediaType, name: asset.name || '' }],
                }),
            })
            if (!res.ok) throw new Error('Failed to create conversation')
            navigate('/show/agent')
        } catch (err) {
            console.error('Failed to create agent conversation:', err)
            toast.error('Failed to start agent conversation')
        }
    }

    const handleOpenSketchEditor = (asset) => {
        setEditingAssetId(asset?._id || null)
        if (asset?.sketch) {
            setSketchEditorState({ sketchId: asset.sketch })
        } else {
            setSketchEditorState({ sketchId: null, initialImageUrl: asset?.url || null, initialName: asset?.name || null })
        }
    }

    const handleCreateSketch = () => {
        setEditingAssetId(null)
        setSketchEditorState({ sketchId: null })
    }

    const handleCloseSketchEditor = () => {
        setSketchEditorState(null)
        setEditingAssetId(null)
    }

    const handleSketchSaveComplete = async ({ sketchId, imageUrl, imageKey, name }) => {
        try {
            if (editingAssetId) {
                await apiFetch(`/api/shows/${show._id}/assets/${editingAssetId}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ name, url: imageUrl, key: imageKey, sketch: sketchId, thumbnail_url: imageUrl, thumbnail_key: imageKey }),
                })
            } else {
                await apiFetch(`/api/shows/${show._id}/assets`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        mediaType: 'image',
                        name,
                        url: imageUrl,
                        key: imageKey,
                        thumbnail_url: imageUrl,
                        thumbnail_key: imageKey,
                        source: 'sketch',
                        sketch: sketchId,
                    }),
                })
            }
            toast.success('Asset saved')
            handleCloseSketchEditor()
            await fetchAssets()
        } catch (error) {
            console.error('Error saving sketch asset:', error)
            toast.error('Failed to save asset')
        }
    }

    const handleDragEnter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragOver(true)
    }
    
    const handleDragLeave = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragOver(false)
    }
    
    const handleDragOver = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragOver(true)
    }
    
    const handleDrop = async (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsDragOver(false)
        
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const files = Array.from(e.dataTransfer.files)
            setLoading(true)
            for(const [index, file] of files.entries()){
                const fileType = file.type.split('/')[0]
                // if(!fileType || mediaTypes.indexOf(fileType) === -1) continue

                try{
                    setLoadingStatus(`Uploading: ${file.name} (${index+1}/${files.length})`)
                    const uploadResponse = await uploadFile(file)
                    const fileName = file.name.replace(/\.[^/.]+$/, '')

                    setLoadingStatus(`Saving: ${fileName} (${index+1}/${files.length})`)

                    const assetResponse = await apiFetch(`/api/shows/${show._id}/assets?episode=${episodeId}&segment=${segmentId}&scene=${sceneId}`, {
                        method: 'POST',
                        body: JSON.stringify({
                            ...uploadResponse,
                            mediaType: fileType,
                            name : fileName,
                            source : 'upload',
                        })
                    })                 

                    if (!assetResponse.ok) throw new Error('Failed to add asset')
                    
                }catch(error){
                    console.error('Error in file upload:', error)
                }
            }

            await fetchAssets()
            setLoading(false)
            setLoadingStatus('')
            setIsDragOver(false)

        }
    }

    const handleFilterTagChange = (tagId, checked) => {
        setSelectedFilterTags(checked ? [...selectedFilterTags, tagId] : selectedFilterTags.filter(t => t !== tagId))
    }

    const filterAssets = () => {
        let result = assets?.filter(asset => asset.tags.some(tag => selectedFilterTags.includes(tag)) || (showUntagged && !asset.tags.length))
        if(searchString){
            result = result?.filter(asset => asset.name.toLowerCase().includes(searchString.toLowerCase()))
        }
        if(!showDraft){
            result = result?.filter(asset => asset.status !== 'draft')
        }
        if(!showApproved){
            result = result?.filter(asset => asset.status !== 'approved')
        }
        return result
    }

    useEffect(()=>{
        const getData = async() =>{
            setLoading(true)
            await fetchAssets()
            setLoading(false)
        }
        
        getData()
    }, [])

    return (
        <div className='flex flex-col w-full h-full relative'>
            {mode === 'assets' &&
                <>
                    <div className='flex items-center justify-between px-10 h-20'>
                        <div className='flex items-center gap-2'>
                            <h1 className='text-2xl font-bold border-l-4 border-primary pl-4'>Assets</h1>
                        </div>
                        <div className='flex items-center gap-2'>
                            {searching && <div className='flex items-center text-xs gap-2 text-secondary-foreground/60'>
                                <LuLoaderCircle className='w-4 h-4 animate-spin' />
                                <span className='text-sm'>Searching...</span>    
                            </div>}
                            <Button type='secondary' icon={<FiPlus className='w-4 h-4' />} onClick={handleCreateSketch}>Create Asset</Button>
                            <Button type='secondary' icon={<FiUpload className='w-4 h-4' />} onClick={() => handleEditAsset()}>Upload Asset</Button>
                            <Button type='secondary' icon={<FiPlus className='w-4 h-4' />} onClick={() => setMode('import')}>Clipro Import</Button>
                        </div>
                    </div>
                    
                    <div className='flex flex-1 gap-10 overflow-hidden'>
                        <div className='flex flex-col w-72 gap-10 py-2 pl-10'>
                            <div className='flex items-center relative'>
                                <Input type='text' placeholder='Search' className='pr-10' onChange={(e) => setSearchString(e.target.value)} value={searchString} />
                                {searchString && <FiX className='w-4 h-4 absolute right-2 top-1/2 -translate-y-1/2 text-secondary-foreground/50 hover:text-secondary-foreground cursor-pointer' onClick={() => setSearchString('')} />}
                            </div>
                            
                            <div className='flex flex-col'>
                                <div className='flex items-center group h-8'>
                                    <span className='text-sm text-secondary-foreground select-none'>Tags</span>
                                    <div className='text-[10px] ml-2 bg-secondary text-secondary-foreground rounded-sm px-2 py-1 hidden cursor-pointer group-hover:flex' onClick={()=>{
                                        setSelectedFilterTags(show.asset_categories.map(tag => tag._id))
                                        setShowUntagged(true)
                                        }}>All
                                    </div>
                                </div>
                                {show.asset_categories.map(tag => (
                                    <div key={tag._id} className='flex items-center gap-2 pl-1 group h-8'>
                                        <Checkbox id={`tag-${tag._id}`} className='cursor-pointer' name={tag._id} checked={selectedFilterTags.includes(tag._id)} onCheckedChange={(checked) => handleFilterTagChange(tag._id, checked)} />
                                        <label htmlFor={`tag-${tag._id}`} className='text-xs text-secondary-foreground capitalize select-none cursor-pointer'>{tag.name}</label>
                                        <div className='text-[10px] ml-2 bg-secondary text-secondary-foreground rounded-sm px-2 py-1 hidden cursor-pointer group-hover:flex' onClick={()=>{
                                            setSelectedFilterTags([tag._id])
                                            setShowUntagged(false)
                                            }}>Only</div>
                                    </div>
                                ))}
                            </div>

                            <div className='flex items-center gap-2 cursor-pointer pl-1 group h-8'>
                                <Checkbox id={`untagged`} name={`untagged`} checked={showUntagged} onCheckedChange={(checked) => setShowUntagged(checked)} />
                                <label htmlFor={`untagged`} className='text-xs text-secondary-foreground capitalize select-none'>Untagged</label>
                                <div className='text-[10px] ml-2 bg-secondary text-secondary-foreground rounded-sm px-2 py-1 hidden cursor-pointer group-hover:flex' onClick={()=>{
                                    setSelectedFilterTags([])
                                    setShowUntagged(true)
                                    }}>Only
                                </div>
                            </div>

                            <div className='flex flex-col'>
                                <div className='flex items-center group h-8'>
                                    <span className='text-sm text-secondary-foreground select-none'>Status</span>
                                </div>
                                <div className='flex items-center gap-2 cursor-pointer pl-1 group h-8'>
                                    <Checkbox id={`draft`} name={`draft`} checked={showDraft} onCheckedChange={(checked) => setShowDraft(checked)} />
                                    <label htmlFor={`draft`} className='text-xs text-secondary-foreground capitalize select-none'>Draft</label>
                                </div>
                                <div className='flex items-center gap-2 cursor-pointer pl-1 group h-8'>
                                    <Checkbox id={`approved`} name={`approved`} checked={showApproved} onCheckedChange={(checked) => setShowApproved(checked)} />
                                    <label htmlFor={`approved`} className='text-xs text-secondary-foreground capitalize select-none'>Approved</label>
                                </div>
                            </div>
                        </div>

                        <div className={`relative flex flex-col h-full py-2 pr-10 flex-1 overflow-y-auto ${isDragOver ? 'bg-secondary/50' : ''}`} onDragEnter={handleDragEnter} onDragLeave={handleDragLeave} onDragOver={handleDragOver} onDrop={handleDrop}>
                            <div className=' text-white w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'>
                                {assets.map((asset) =>  <Asset key={asset._id} asset={asset} onEdit={handleEditAsset} onDelete={handleDelete} onDownload={handleDownload} onStatusChange={handleStatusChange} onPreview={handleAssetsPreview} onComment={handleComment} onAgent={handleAgent} onSketchEdit={handleOpenSketchEditor} />)}
                            </div>
                            
                        </div>
                    </div>
                    
                    <div className='flex items-center gap-2 py-2 px-10'>
                        <Button type='secondary' icon={<FaAngleLeft className='w-4 h-4' />} onClick={handlePreviousPage} disabled={page === 1}/>
                        <span>{page}/{totalPages}</span>
                        <Button type='secondary' icon={<FaAngleRight className='w-4 h-4' />} onClick={handleNextPage} disabled={page===totalPages}/>
                        <span>{`${((page - 1) * pageSize)+1}-${((page - 1) * pageSize)+pageSize > totalAssets ? totalAssets : ((page - 1) * pageSize)+pageSize} of ${totalAssets}`}</span>
                    </div>
                    
                </>
            }
            {mode === 'import' && <WscBrowser onSelect={handleWscImport} />}
            {sketchEditorState && (
                <div className='absolute inset-0 z-50 bg-background'>
                    <DragPreviewProvider>
                        <SketchEditor
                            sketchId={sketchEditorState.sketchId}
                            initialImageUrl={sketchEditorState.initialImageUrl}
                            initialName={sketchEditorState.initialName}
                            onClose={handleCloseSketchEditor}
                            onSaveComplete={handleSketchSaveComplete}
                        />
                    </DragPreviewProvider>
                </div>
            )}
            {loading && <Loader status={loadingStatus} showProgress={isUploading} progress={uploadProgress} />}
        </div>
    )
}